import hasFeature from 'modules/core/lib/hasFeature'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'

export const hasAccess = () => {
  const currentUser = users.current
  const currentEmployee = currentUser.isNew
    ? undefined
    : employees.find({
        access_id: currentUser.attributes.id,
      })
  return hasFeature('one_on_ones') && !!currentEmployee
}
